import { render } from "./AncillaryBrandView.vue?vue&type=template&id=26cbc872&scoped=true"
import script from "./AncillaryBrandView.vue?vue&type=script&lang=js"
export * from "./AncillaryBrandView.vue?vue&type=script&lang=js"

import "./AncillaryBrandView.vue?vue&type=style&index=0&id=26cbc872&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-26cbc872"]])

export default __exports__